import React from 'react';
import { Stack, Typography } from '@krakentech/coral';

import { Line } from './index.styled';

const LineSeparator = ({ text }: { text?: string }) => {
  return (
    <Stack alignItems="center" gap="xsSm">
      <Line />
      {text && (
        <>
          <Typography component="span" variant="h3" color="text-dark">
            {text}
          </Typography>
          <Line />
        </>
      )}
    </Stack>
  );
};

export default LineSeparator;
